var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#398260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4642 3.88805C11.4418 4.57823 12.4599 4.6553 13.7621 4.89492C14.9468 5.11486 15.1982 6.3248 14.6571 7.86492C14.6243 7.80956 14.5906 7.7548 14.5558 7.70067L14.6571 7.86492C15.4823 9.26667 15.4761 10.7849 13.6901 11.5617C10.5103 12.9454 10.3208 15.6707 7.31532 14.2037C6.88926 13.9939 6.50662 13.7055 6.18751 13.3538L6.07051 13.2205L5.96195 13.2019C3.94482 12.8447 2.6207 11.7512 3.84582 8.96123C4.92976 6.4958 3.9617 4.06973 7.28607 4.17773H7.2872C8.20295 3.3188 9.25876 3.03923 10.4636 3.88805H10.4642ZM7.36651 6.38105C5.97263 7.38173 5.51363 9.2453 6.44176 10.6926C6.66101 11.0364 6.94612 11.3333 7.28068 11.5664C7.61523 11.7995 7.99261 11.964 8.39105 12.0505C8.78949 12.1371 9.20112 12.1439 9.60221 12.0706C10.0033 11.9973 10.3859 11.8454 10.728 11.6235C12.1669 10.6898 12.3638 8.87855 11.6528 7.31086C10.9243 5.7038 8.92463 5.26223 7.36651 6.38105Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPax);
export default __webpack_public_path__ + "static/media/pax.7e957aa10d394d39f2f0228eb435876e.svg";
export { ForwardRef as ReactComponent };